import GoogleMapsApi from './googleMapApi';

class AutocompleteAddress {
    constructor() {
        console.log('teste');
        this.gmapApi = new GoogleMapsApi();

        this.autocomplete;
        this.addressField;

        this.initAutocomplete();
    }

    initAutocomplete() {
        this.addressField = document.querySelector('input[name="search_address"]');

        this.gmapApi.load().then(() => {
            this.autocomplete = new google.maps.places.Autocomplete(this.addressField, {
                componentRestrictions: { country: ["br"] }
            });

            this.autocomplete.addListener("place_changed", () => {
                let stores = this.autocomplete.getPlace();

                console.log(stores.geometry.location.toJSON());

                document.querySelector('input[name="lat"]').value = stores.geometry.location.lat();
                document.querySelector('input[name="lng"]').value = stores.geometry.location.lng();
            });
        });
    }
}

export default AutocompleteAddress;
